var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00008 1.16666C3.77842 1.16666 1.16675 3.77833 1.16675 6.99999C1.16675 10.2217 3.77842 12.8333 7.00008 12.8333C10.2217 12.8333 12.8334 10.2217 12.8334 6.99999C12.8297 3.77988 10.2202 1.17041 7.00008 1.16666ZM10.3674 5.15277L7.03994 9.66825C6.96059 9.77354 6.84225 9.84253 6.71154 9.85971C6.58082 9.8769 6.44868 9.84084 6.3448 9.75964L3.96869 7.85992C3.75902 7.69213 3.72506 7.38612 3.89286 7.17645C4.06065 6.96677 4.36665 6.93282 4.57633 7.10062L6.55772 8.68582L9.58473 4.5777C9.68399 4.42875 9.85708 4.3464 10.0353 4.36334C10.2135 4.38028 10.3679 4.49378 10.4373 4.65877C10.5067 4.82376 10.4799 5.01354 10.3674 5.15277Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSolid);
export default __webpack_public_path__ + "static/media/check-circle-solid.cef9de54.svg";
export { ForwardRef as ReactComponent };